import { useCallback, useEffect, useState } from 'react';

type Theme = 'light' | 'midnight';

const STORAGE_KEY = 'theme';
const DEFAULT: Theme = 'midnight';

function readInitial(): Theme {
  if (typeof window === 'undefined') return DEFAULT;
  try {
    const stored = window.localStorage?.getItem(STORAGE_KEY);
    return stored === 'light' || stored === 'midnight' ? stored : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function useTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(readInitial);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* localStorage indisponível em alguns contextos (private mode); ignora */
    }
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => (t === 'midnight' ? 'light' : 'midnight'));
  }, []);

  return { theme, toggle };
}
